<template>
  <div class="student-user-container">
    <div class="banner">
      <div class="banner-img">
        <img src="@/assets/images/banner/banner_4.png" alt="" />
      </div>
    </div>
    <div class="breadcrumb-section flex-row-start">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
        <el-breadcrumb-item :to="{ path: '/list' }"
          >满分学堂</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/user' }"
          >个人中心</el-breadcrumb-item
        >
        <el-breadcrumb-item
          ><span class="c-40b8ee">弱科分析</span></el-breadcrumb-item
        >
      </el-breadcrumb>
    </div>
    <div class="categroy-section ">
      <div class="categroy clearfix">
        <template>
          <dl>
            <dt><i class="wkcourse_icon"></i>学段</dt>
            <dd>
              <a
                href="javascript:;"
                v-for="(v, i) in stageList"
                :key="i"
                :class="{ crt: stageIng.code === v.code }"
                @click="onStaget(v)"
                >{{ v.name }}</a
              >
            </dd>
          </dl>
          <dl class="wktype">
            <dt><i class="wkcourse_icon"></i>学科</dt>
            <dd>
              <a
                href="javascript:;"
                v-for="(val, key) in subjectList"
                :key="key"
                :class="{ crt: subjectIng.code === val.code }"
                @click="onSubject(val)"
                >{{ val.name }}</a
              >
            </dd>
          </dl>
        </template>
      </div>
    </div>
    <div class="content-section">
      <div class="list-title flex-between">
        <div class="list-title-num">
          我已学习了<span class="graph-num">{{ pageTotal }}</span
          >节课
        </div>
        <div class="list-title-difficulty flex-row-end">
          掌握度：
          <div class="graph-box">
            <span class="graph weaknesses_level_1"></span>
            <span class="graph-font">高</span>
          </div>
          <div class="graph-box">
            <span class="graph weaknesses_level_2"></span>
            <span class="graph-font">中</span>
          </div>
          <div class="graph-box">
            <span class="graph weaknesses_level_3"></span>
            <span class="graph-font">低</span>
          </div>
        </div>
      </div>
      <div class="list-section flex-wrap-start" v-if="pageTotal > 0">
        <div
          class="list-item"
          v-for="(item, index) in list"
          :key="index"
          :class="`weaknesses_level_${item.level}`"
        >
          <div class="item-course">
            <el-image :src="item.ke_images_url" class="item" lazy></el-image>
          </div>
          <div class="item-course-title height-text-hidden">
            {{ item.ke_title }}
          </div>
          <div class="item-report-hover column">
            <div>正 确 率</div>
            <div class="correct">{{ item.correct }}%</div>
            <a :href="`/#/video/${item.video_id}`" target="_blank"
              >点击再次学习>>></a
            >
          </div>
        </div>
      </div>
      <div class="list-container" v-else>
        <div class="column pt50">
          <img src="../../assets/images/list_null.png" alt="" srcset="" />
          <div class="null">暂无数据~~</div>
        </div>
      </div>
    </div>
    <div class="clearfix list-page">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :current-page="query.page"
        :page-size="query.pageSize"
        :total="pageTotal"
        @current-change="handlePageChange"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
// import md5 from 'js-md5';
import "../../assets/css/dialog.css";
export default {
  components: {},
  data() {
    return {
      query: {
        page: 1,
        pageSize: 100,
      },
      list: [],
      pageTotal: 0,
      stageList: [],
      subjectList: [],
      subjectIng: {},
      stageIng: {},
    };
  },
  created() {
    this.getStageSubjectData();
  },
  methods: {
    getStageSubjectData() {
      this.getRequest("/wenjiaoopne/kc/user/getValidityStageSubject", {
        verify: 1,
        notIn: 1311,
      })
        .then((result) => {
          this.stageList = result.data;
          this.stageIng = this.stageList[0];
          this.subjectList = this.stageIng.children;
          this.subjectIng = this.subjectList[0];
          this.getList();
        })
        .catch(() => {});
    },
    getList(loading) {
      this.getRequest(
        "/wenjiaoopne/kc/user/course/note/getWeaknessesList",
        Object.assign(this.query, {
          stage_name: this.stageIng.name,
          subject_name: this.subjectIng.name,
        })
      )
        .then((result) => {
          if (loading) {
            this.loading.close();
          }
          this.pageTotal = result.data.total_count;
          this.list = result.data.list;
        })
        .catch(() => {
          if (loading) {
            this.loading.close();
          }
        });
    },
    onStaget(item) {
      this.onLoading();
      this.stageIng = item;
      this.subjectList = this.stageIng.children;
      this.subjectIng = this.subjectList[0];
      this.getList(true);
    },
    onSubject(item) {
      this.onLoading();
      this.subjectIng = item;
      this.getList(true);
    },
    handlePageChange(v) {
      this.$set(this.query, "page", v);
      this.getList();
    },
    onLoading() {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
      });
    },
  },
};
</script>
<style scoped>
.student-user-container {
  background-color: #f1f1f1;
}

.student-user-container .banner {
  width: 100%;
  height: 173px;
  background-image: url("../../assets/images/banner/bg_4.jpg");
  background-size: 100% 100%;
  background-position: center center;
  background-repeat: no-repeat;
}

.student-user-container .banner-img {
  width: 1195px;
  margin: 0 auto;
  height: inherit;
}

.student-user-container .banner-img > img {
  width: 100%;
  height: 100%;
}

.breadcrumb-section {
  width: 1195px;
  margin: 0 auto;
  height: 45px;
  border-bottom: 1px solid #f1f1f1;
  background-color: #fff;
}

.breadcrumb {
  padding: 0 15px;
}

.categroy-section {
  width: 1195px;
  margin: 0 auto;
  background-color: #fff;
  border-bottom: 1px solid #f1f1f1;
}

.categroy-section .categroy {
  width: 100%;
  /* height: 180px; */
  background-color: #ffffff;
}

.categroy-section .categroy dl {
  margin: 0px 20px;
  height: 34px;
  padding: 13px 0px;
}

.categroy-section .categroy dl dt {
  width: 72px;
  float: left;
  color: #4f4e4e;
  font-size: 16px;
  line-height: 34px;
  border-right: 1px solid #dddddd;
}

.categroy-section .categroy dl dt i.wkcourse_icon {
  width: 14px;
  height: 19px;
  display: block;
  background: url(https://wk.canpoint.net/Template/style1/style_img/wkcourse_icon.png)
    0px 0px;
  float: left;
  margin: 8px 10px 0px 0px;
}

.categroy-section .categroy dl.wktype {
  border-top: 1px solid #dddddd;
}

.categroy-section .categroy dl.wktype dt i.wkcourse_icon {
  background-position: 0px -25px;
  margin-top: 10px;
}

.categroy-section .categroy dl dd {
  float: left;
  height: 26px;
  margin-top: 2px;
  margin-left: 15px;
}

.categroy-section .categroy dl dd a {
  float: left;
  line-height: 26px;
  color: #4f4f4f;
  font-size: 14px;
  text-align: center;
  padding: 2px 20px;
}

.categroy-section .categroy dl dd a.crt {
  background-color: #02a4ef;
  color: #fff;
}

.student-user-container .content-section {
  position: relative;
  width: 1165px;
  min-height: 500px;
  margin: 0 auto;
  padding: 0 15px;
  background-color: #fff;
}
.student-user-container .content-section .list-title {
  padding: 30px 20px;
}

.list-title-difficulty {
  font-size: 14px;
}

.list-title-difficulty .graph-box {
  padding-right: 15px;
}
.list-title-num .graph-num {
  font-size: 25px;
  color: #40b8ee;
  display: inline-block;
  margin: 0 8px;
}
.weaknesses_level_1 {
  background-color: #90d26c;
}
.weaknesses_level_2 {
  background-color: #6e97de;
}
.weaknesses_level_3 {
  background-color: #dda4b0;
}
.list-title-difficulty .graph {
  display: inline-block;
  width: 28px;
  height: 12px;
  margin: 0 5px;
}
.list-section {
  padding: 0 30px;
}
.list-section .list-item {
  position: relative;
  width: 180px;
  height: 155px;
  margin: 0px 20px 30px 20px;
}
.item-report-hover {
  text-align: center;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  opacity: 0;
  transition: all 0.4s ease-in;
  font-size: 14px;
  color: #fff;
}
.item-report-hover .correct {
  padding: 5px 0;
  font-size: 25px;
}
.item-report-hover a {
  font-size: 14px;
  color: #fff;
}
.list-section .list-item:hover .item-report-hover {
  opacity: 1;
}
.list-section .list-item .item-course {
  width: 100%;
  height: 100px;
  background-color: #f1f1f1;
}
.item-course-title {
  padding: 8px 10px;
  font-size: 14px;
  height: 34px;
  color: #fff;
}
.list-page {
  width: 1195px;
  margin: 0 auto;
  text-align: right;
  padding: 10px 0;
}
</style>
